/* eslint-disable no-nested-ternary */
import { Container, Group } from './styles';

import filter from '../../../../assets/images/icons/filter.svg';
import FormGroup from '../../../../components/FormGroup';
import Input from '../../../../components/Input';
import { FilterRadioButtonsContainer } from '../../../../components/FilterRadioButtonsContainer';
import FilterRadioButton from '../../../../components/FilterRadioButtons';
import { ChangeEvent } from 'react';

interface FiltersI {
  workplaceCode: string;
  handleWorkplaceCodeChange: (event: ChangeEvent<HTMLInputElement>) => void;
  streetName: string;
  handleStreetNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleStatusChange: (status: '' | 'Ativo' | 'Inativo') => void;
  workplaceName: string;
  handleWorkplaceNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
  selectedStatus: '' | 'Ativo' | 'Inativo';
}

export default function Filters({
  workplaceCode,
  handleWorkplaceCodeChange,
  streetName,
  handleStreetNameChange,
  handleStatusChange,
  selectedStatus,
  workplaceName,
  handleWorkplaceNameChange,
}: FiltersI) {
  return (
    <Container>
      <header>
        <img src={filter} alt="filter" className="primaryColor" />
        <div>Pesquise através dos filtros abaixo</div>
      </header>

      <div>
        <Group>
          <div className="title">
            Código
          </div>
          <FormGroup>
            <Input
              value={workplaceCode}
              onChange={handleWorkplaceCodeChange}
              placeholder="Código do local de trabalho"
            />
          </FormGroup>
        </Group>

        <Group>
          <div className="title">
            Denominação
          </div>
          <FormGroup>
            <Input
              value={workplaceName}
              onChange={handleWorkplaceNameChange}
              placeholder="Nome do local de trabalho"
            />
          </FormGroup>
        </Group>

        <Group>
          <div className="title">
            Logradouro
          </div>
          <FormGroup>
            <Input
              value={streetName}
              onChange={handleStreetNameChange}
              placeholder="Logradouro"
            />
          </FormGroup>
        </Group>

        <FilterRadioButtonsContainer>
          <FilterRadioButton
            onClick={() => handleStatusChange('')}
            selected={selectedStatus === ''}
          >
            Todos
          </FilterRadioButton>
          <FilterRadioButton
            onClick={() => handleStatusChange('Ativo')}
            selected={selectedStatus === 'Ativo'}
          >
            Ativos
          </FilterRadioButton>
          <FilterRadioButton
            onClick={() => handleStatusChange('Inativo')}
            selected={selectedStatus === 'Inativo'}
          >
            Inativos
          </FilterRadioButton>
        </FilterRadioButtonsContainer>
      </div>
    </Container>
  );
}
